import { render, staticRenderFns } from "./StaticPageLayout.vue?vue&type=template&id=4911a719"
import script from "./StaticPageLayout.vue?vue&type=script&lang=js"
export * from "./StaticPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports